import { defineComponent as _defineComponent } from 'vue'
import { computed, getCurrentInstance, onMounted, onActivated, onBeforeUnmount, onDeactivated } from 'vue'
    import LoadingIndicator from '@/components/LoadingIndicator.vue'
    import ProgressBar from '@/components/onboardingV2/progressBar.vue'
    import AdviceBubble from '@/components/onboardingV2/adviceBubble.vue'
    import { getSafeAreaPaddingBottom, getSafeAreaPaddingTop } from '@/utils/safeAreaUtils'
    import { setSafeAreaConfig } from '@/nativeWebInteraction/nativeWebInteraction'
    import { log } from '@/utils/logger'
    import { logEvent } from '@/utils/http-client'
    import { appRoutePaths } from '@/routes/appRoutes'
    import backArrowIcon from '@/assets/images/onboarding-v2-back-icon.svg'

    interface Props {
        pageTitle?: string
        hasHeader?: boolean
        hasBack?: boolean
        backAction?: (() => void) | null
        loading?: boolean
        loadingTitle?: string
        errorText?: string
        backgroundColor?: string
        showProgressBar?: boolean
        currentStep?: number
        totalSteps?: number
        adviceText?: string
    }

    
export default /*#__PURE__*/_defineComponent({
  __name: 'OnboardingV2',
  props: {
    pageTitle: { default: '' },
    hasHeader: { type: Boolean, default: true },
    hasBack: { type: Boolean, default: true },
    backAction: { type: [Function, null], default: null },
    loading: { type: Boolean, default: false },
    loadingTitle: { default: 'Loading...' },
    errorText: { default: '' },
    backgroundColor: { default: 'black' },
    showProgressBar: { type: Boolean, default: false },
    currentStep: { default: 1 },
    totalSteps: { default: 5 },
    adviceText: { default: '' }
  },
  setup(__props: any) {

const props = __props as { pageTitle: string, hasHeader: boolean, hasBack: boolean, backAction: (() => void) | null, loading: boolean, loadingTitle: string, errorText: string, backgroundColor: string, showProgressBar: boolean, currentStep: number, totalSteps: number, adviceText: string }

    

    const instance = getCurrentInstance()
    const router = instance?.proxy.$router

    const containerStyle = computed(() => {
        // Ensure minimum top padding for web browsers without safe area insets
        const topPadding = Math.max(getSafeAreaPaddingTop(), 16)
        let style = `padding-top: ${topPadding}px; padding-bottom: ${getSafeAreaPaddingBottom()}px;`
        if (props.backgroundColor) {
            style += `background-color: ${props.backgroundColor};`
        }
        return style
    })

    const goBack = () => {
        logEvent('click_advisor_onboarding_v2_back_button')
        if (props.backAction) {
            log.info('OnboardingV2Layout has a back action, so executing that on back click')
            props.backAction()
        } else {
            log.info('OnboardingV2Layout does not have a back action, so calling router.back()')
            if (window.history.length > 1) {
                log.info('OnboardingV2Layout has history, so calling router.back()')
                router?.back()
            } else {
                log.info('OnboardingV2Layout does not have history, so calling router.replace()')
                router?.replace(appRoutePaths.TODAY)
            }
        }
    }

    // Set safe area config to black background when mounted
    onMounted(async () => {
        await setSafeAreaConfig({ enabled: true, backgroundColor: '#000000' })
    })

    // Also set safe area config when component is activated (returns from cache)
    onActivated(async () => {
        await setSafeAreaConfig({ enabled: true, backgroundColor: '#000000' })
    })

    // Reset safe area config when component is destroyed
    onBeforeUnmount(async () => {
        await setSafeAreaConfig({ enabled: true, backgroundColor: '#FFFFFF' })
    })

    // Reset safe area config when component is deactivated (cached)
    onDeactivated(async () => {
        await setSafeAreaConfig({ enabled: true, backgroundColor: '#FFFFFF' })
    })

return { __sfc: true,props, instance, router, containerStyle, goBack, LoadingIndicator, ProgressBar, AdviceBubble, backArrowIcon }
}

})